import { render } from "./BarChart.vue?vue&type=template&id=5ce4c1c0&scoped=true&ts=true"
import script from "./BarChart.vue?vue&type=script&lang=ts"
export * from "./BarChart.vue?vue&type=script&lang=ts"

import "./BarChart.vue?vue&type=style&index=0&id=5ce4c1c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce4c1c0"]])

export default __exports__